import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { resolveAppModule, stripRouteQuery } from '../../navigation/app-module-resolver';

/** Header mang mã module rail của màn đang mở — khớp SystemErrorRuntime.AppModuleHeader (BE). */
export const APP_MODULE_HEADER = 'X-App-Module';
/** Header mang route trang đang mở (không query) — khớp SystemErrorRuntime.AppRouteHeader (BE). */
export const APP_ROUTE_HEADER = 'X-App-Route';

/**
 * E-118 — gắn "người dùng đang đứng ở đâu" vào mọi lời gọi API, để lỗi máy chủ được xếp đúng
 * module rail trên màn Lỗi hệ thống thay vì suy từ slug đường dẫn API ('Invoice', 'Hrm'…).
 *
 * CHỈ gắn vào lời gọi API của chính app: interceptor đứng TRƯỚC apiPrefixInterceptor nên lời gọi
 * nội bộ còn là đường dẫn tương đối; URL tuyệt đối là máy chủ bên ngoài — gắn header lạ vào đó là
 * làm hỏng preflight CORS của họ. Bỏ qua tệp tĩnh (i18n, asset). Route bỏ query — bộ lọc, token
 * không được rời trình duyệt qua kênh này. Hai header phải có trong danh sách CORS của BE
 * (SecurityExtensions.CorsAllowedHeaders), nếu không mọi lời gọi khác origin chết ở preflight.
 */
export const appLocationInterceptor: HttpInterceptorFn = (req, next) => {
  if (/^[a-z][a-z0-9+.-]*:/i.test(req.url) || /(^|\/)assets\//.test(req.url)) return next(req);

  const router = inject(Router, { optional: true });
  const route = stripRouteQuery(router?.url);
  if (!route || !route.startsWith('/')) return next(req);

  let headers = req.headers.set(APP_ROUTE_HEADER, route.slice(0, 512));
  const module = resolveAppModule(route);
  if (module) headers = headers.set(APP_MODULE_HEADER, module.id);
  return next(req.clone({ headers }));
};
